.root {
  align-items: center;
  border-radius: 8px;
  display: flex;
  font-size: 14px;
  gap: 8px;
  padding: 12px 16px;
}

.root-variant-error {
  background: var(--color-destructive);
  color: var(--color-destructive-foreground);
}

.root-variant-info {
  background: var(--color-badge-info-bg);
  color: var(--color-badge-info-fg);
}

.root-variant-success {
  background: var(--color-success);
  color: var(--color-success-foreground);
}

.root-variant-warning {
  background: var(--color-warning);
  color: var(--color-warning-foreground);
}

.icon {
  flex-shrink: 0;
}
